export const abouts = [
    {
        head: 'ASCT का लक्ष्य',
        desc: 'ASCT का लक्ष्य है कि प्रदेश के सभी अधिवक्ता इस टीम से जुड़े और टीम के किसी भी विधिक सदस्य की असामयिक मृत्यु पर उसके परिवार को सहयोग किया जाय।'
    },
    {
        head: 'ASCT से कौन जुड़ सकता है',
        desc: 'उत्तर प्रदेश के समस्त अधिवक्ता जिनका पंजीकरण उत्तर प्रदेश बार काउंसिल से हुआ है, वे सभी अधिवक्ता जुड़ सकते हैं।'
    },
    {
        head: 'सदस्यता शुल्क:',
        desc: 'ASCT से जुड़ने हेतु कोई सदस्यता शुल्क नहीं देना है। सदस्यता निःशुल्क है।'
    },
    {
        head: 'ASCT से कैसे जुड़ें',
        desc: 'ASCT से जुड़ने के लिए वेबसाइट https://asctup.com पर जाकर रजिस्ट्रेशन कर लें, साथ ही ASCT के टेलीग्राम ग्रुप से अवश्य जुड़ जाएं, समस्त अपडेट और जानकारी आपको टेलीग्राम ग्रुप से मिल जाएगी।'
    }
]